import {CustomerProjectListState} from "../store/customer_projects_state";
import {Reducer} from "redux";
import {
    CustomerProjectListAction,
    CustomerProjectListActionType,
    ICallbackGetProjectListAction,
    ICallbackSearchProjectListAction,
    ICallbackGetProjectCountAction, ICallbackGetEntryNumOrderProjectListAction,
} from "../action/customer_projects_action";

const initialState: CustomerProjectListState = {
    projects: [],
    projectCount: 0,
    companiesWithProjectID: [],
    isLoading: false,

    entryNumOrderProjects: [],
    companiesWithEntryNumOrderProjectID: [],

    newlyArrivedProjects: [],
    companiesWithNewlyArrivedProjectID: [],
};

const customerProjectListReducer: Reducer<CustomerProjectListState> = (state = initialState, action: CustomerProjectListAction): CustomerProjectListState => {
    switch (action.type) {

        case CustomerProjectListActionType.REQUEST_GET_ENTRY_NUM_ORDER_PROJECT_LIST: {
            return Object.assign({}, state, {
            });
        }
        case CustomerProjectListActionType.CALLBACK_GET_ENTRY_NUM_ORDER_PROJECT_LIST: {
            const _action = action as ICallbackGetEntryNumOrderProjectListAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    newlyArrivedProjects: _action.item ? _action.item.newlyArrivedProjects : [],
                    companiesWithNewlyArrivedProjectID: _action.item ? _action.item.companiesWithNewlyArrivedProjectID : [],
                    entryNumOrderProjects: _action.item ? _action.item.entryNumOrderProjects : [],
                    companiesWithEntryNumOrderProjectID: _action.item ? _action.item.companiesWithEntryNumOrderProjectID : [],
                });
            } else {
                return Object.assign({}, state, {
                });
            }
        }

        case CustomerProjectListActionType.REQUEST_GET_PROJECT_LIST: {
            return Object.assign({}, state, {
                projects: state.projects,
                projectCount: state.projectCount,
                companiesWithProjectID: state.companiesWithProjectID,
                isLoading: true,
            });
        }
        case CustomerProjectListActionType.CALLBACK_GET_PROJECT_LIST: {
            const _action = action as ICallbackGetProjectListAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    projects: _action.item ? _action.item.projects : [],
                    projectCount: _action.item ? _action.item.projectCount : 0,
                    companiesWithProjectID: _action.item ? _action.item.companiesWithProjectID : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    projects: state.projects,
                    projectCount: state.projectCount,
                    companiesWithProjectID: state.companiesWithProjectID,
                    isLoading: false,
                });
            }
        }

        // ToDo: 削除保留）TotalCountsの取得時のBackendコストを抑えるために、分離したがPager機能との整合性が複雑になるためREQUEST_GET_PROJECT_LIST時に実行されるように変更した
        case CustomerProjectListActionType.REQUEST_GET_PROJECT_COUNT: {
            return Object.assign({}, state, {
                projects: state.projects,
                projectCount: state.projectCount,
                companiesWithProjectID: state.companiesWithProjectID,
                isLoading: true,
            })
        }
        case CustomerProjectListActionType.CALLBACK_GET_PROJECT_COUNT: {
            const _action = action as ICallbackGetProjectCountAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    projects: state.projects,
                    projectCount: _action.item ? _action.item.projectCount : 0,
                    companiesWithProjectID: state.companiesWithProjectID,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    projects: state.projects,
                    projectCount: state.projectCount,
                    companiesWithProjectID: state.companiesWithProjectID,
                    isLoading: false,
                });
            }
        }

        case CustomerProjectListActionType.REQUEST_SEARCH_PROJECT_LIST: {
            return Object.assign({}, state, {
                projects: state.projects,
                projectCount: state.projectCount,
                companiesWithProjectID: state.companiesWithProjectID,
                isLoading: true,
            });
        }
        case CustomerProjectListActionType.CALLBACK_SEARCH_PROJECT_LIST: {
            const _action = action as ICallbackSearchProjectListAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    projects: _action.item ? _action.item.projects : [],
                    projectCount: _action.item ? _action.item.projectCount : 0,
                    companiesWithProjectID: _action.item ? _action.item.companiesWithProjectID : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    projects: state.projects,
                    projectCount: state.projectCount,
                    companiesWithProjectID: state.companiesWithProjectID,
                    isLoading: false,
                });
            }
        }

        default:
            return state;
    }
};

export default customerProjectListReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/customer_projects_reducer.ts